import { getStandardizeDateTimeFormat } from "./util";

var isDev = /localhost:56\d{2}/.test(location.href);
var isSITUAT = location.href.indexOf("-sit") !== -1 || location.href.indexOf("-uat") !== -1;
const MAX_FILE_SIZE = 10 * 1024 * 1024;
let currentFile;

const isFalseyValue = (value) =>
  value === undefined || value === null || (typeof value === "string" && value.trim() === "");

const urlQueryFormatter = (url, sendParams) => {
  return `${url}?${Object.entries(sendParams)
    .reduce((acc, [key, value]) => {
      if (!isFalseyValue(value)) {
        acc.push(`${key}=${encodeURIComponent(value)}`);
      }

      return acc;
    }, [])
    .join("&")}`;
};

const getFeedbacks = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/member/feedbacks`,
  }).done(({ result: { count, list } }) => {
    if (count > 0) {
      $(".feedback-section__feedback-empty").addClass("hide");
      $(".feedback-section__feedback-list").html(
        list.map(({ content, created, imgUploadUrl, managerReply, serReply, tecReply, title }) => {
          return `
          <div class="feedback-list-item" 
          ${imgUploadUrl ? `data-img-url=${imgUploadUrl}` : ""}
          ${managerReply ? `data-manager-reply="${managerReply}"` : ""}
          ${serReply ? `data-ser-reply="${serReply}"` : ""}
          ${tecReply ? `data-tec-reply="${tecReply}"` : ""}
           >
            <div>
              <div class="feedback-list-item__title">
                <p class="feedback-list-item__title-category">${title}</p>
                <p>${getStandardizeDateTimeFormat(created)}</p>
              </div>
              <div class="feedback-list-item__content">
                <p>${content}</p>
              </div>
            </div>
            <div class="feedback-list-item__arrow">
              <img src="img/icon-arrow.svg">
            </div>
          </div>`;
        })
      );
      $(".feedback-section__feedback-list").removeClass("hide");

      $(".feedback-list-item").on("click", function () {
        const imgUploadUrl = $(this).data("imgUrl");
        const managerReply = $(this).data("managerReply");
        const serReply = $(this).data("serReply");
        const tecReply = $(this).data("tecReply");

        $(".feedback-detail-section").removeClass("hide").siblings().addClass("hide");
        $(".feedback-detail-section__detail").html(`
          <p>${$(this).find(".feedback-list-item__title-category").text()}</p>
          <p>${$(this).find(".feedback-list-item__content p").text()}</p>
          ${
            imgUploadUrl
              ? `<div class="feedback-list-item__image">
                <img
                  src=${isDev ? "/api" : ""}${urlQueryFormatter("/web/rest/member/retrieveFeedbackImg", {
                  path: imgUploadUrl,
                })}
                />
              </div>`
              : ""
          }
        `);
        $(".feedback-detail-section__replies").html(`
          ${serReply ? `<div><p>客服回复</p><p>${serReply}</p></div>` : ""}
          ${tecReply ? `<div><p>技术回复</p><p>${tecReply}</p></div>` : ""}
          ${managerReply ? `<div><p>经理意见</p><p>${managerReply}</p></div>` : ""}
          `);
      });
    }
  });
};

const getFeedbackCategories = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/member/feedbackCategory?updated=1`,
  }).done(({ result }) => {
    const select = $("#feedback-category-select");

    select.empty();

    result.forEach(({ id, topic }) => {
      select.append(`<option label=${topic} value=${id}>${topic}</option>`);
    });

    select.niceSelect();

    $(".nice-select").addClass("wide");
    $(".nice-select .current").text("请选择问题").css("color", "rgba(0, 0, 0, 0.25)");

    select.on('change', function() {
      if ($(this).val() !== "") {
        $(".nice-select .current").css("color", "");
      }
    });
  });
};

$(".button-feedback").on("click", function () {
  updateFile();
  $("#modal-feedback").addClass("active");
  getFeedbacks();
});

$(".feedback-section__feedback-create button").on("click", function () {
  updateFile();
  $(".feedback-create-section").removeClass("hide").siblings().addClass("hide");
  $("#feedback-input").val("");
  $(".feedback-create-section__action button:first").attr("disabled", "disabled");
  getFeedbackCategories();
});

$(".feedback-create-section__button-back, .feedback-create-section__action button:last-child").on("click", function () {
  $(".feedback-section").removeClass("hide").siblings().addClass("hide");
  $("#feedback-category-select").niceSelect("destroy");
  getFeedbacks();
});

$(".feedback-detail-section__button-back").on("click", function () {
  $(".feedback-section").removeClass("hide").siblings().addClass("hide");
  getFeedbacks();
});

$("#feedback-input, #feedback-category-select").on("input change", function () {
  if ($("#feedback-input").val() && $("#feedback-category-select").val()) {
    $(".feedback-create-section__action button:first").removeAttr("disabled");
  } else {
    $(".feedback-create-section__action button:first").attr("disabled", "disabled");
  }
});

const submitFeedback = (content, image, title, topicId) => {
  const formData = new FormData();

  if (image) {
    formData.append("file", image);
  }

  formData.append("data", new Blob([JSON.stringify({ content, title, topicId })], { type: "application/json" }));

  $.ajax({
    type: "POST",
    url: `${isDev ? "/api" : ""}/web/rest/member/sendfeedback`,
    data: formData,
    processData: false,
    contentType: false,
  })
    .done(({ statusCode, message }) => {
      if (statusCode === 200) {
        window.alertBox({
          type: "success",
          message,
          confirmFunc: function () {
            $(".feedback-section").removeClass("hide");
            $(".feedback-create-section").addClass("hide");
            $("#feedback-category-select").niceSelect("destroy");
            getFeedbacks();
          },
        });
      } else {
        window.alertBox({ type: "error", message });
      }
    })
    .catch(({ responseJSON: { message } = {} }) => {
      window.alertBox({ type: "error", message: message || "暂时无法连接服务器，请稍后再试！" });
    });
};

$(".feedback-create-section__action button:first").on("click", function () {
  const title = $("#feedback-category-select :selected").attr("label");
  const topicId = $("#feedback-category-select :selected").attr("value");
  const value = $("#feedback-input").val();
  submitFeedback(value, currentFile, title, topicId);
});

$("#feedback-upload-image-button").on("click", function () {
  $("#feedback-upload-image-input").click();
});

const updateFile = (file) => {
  currentFile = file;

  if (currentFile) {
    $("#feedback-create-section__upload-field-wrapper").addClass("has-image");
    $("#feedback-create-section__upload-field-placeholder").addClass("hide");
    $("#feedback-create-section__upload-field-detail").removeClass("hide");

    const { name = "" } = currentFile;
    $("#feedback-create-section__upload-field-detail span").text(name);
  } else {
    $("#feedback-upload-image-input").val(undefined);
    $("#feedback-create-section__upload-field-wrapper").removeClass("has-image");
    $("#feedback-create-section__upload-field-placeholder").removeClass("hide");
    $("#feedback-create-section__upload-field-detail").addClass("hide");
  }
};

$("#feedback-upload-image-input").change(function ({ target: { files } }) {
  if (!files?.length) {
    updateFile();
    return;
  }

  const file = files.item(0);

  if (file && file.size < MAX_FILE_SIZE) {
    updateFile(file);
  } else {
    window.alertBox({ type: "error", message: "上传档案必须小于10MB，请重新上传" });
  }
});

$("#feedback-upload-image-close").click(() => updateFile());

$("#feedback-upload-image-field-name").click(() => {
  $("#modal-feedback-upload-image-preview").addClass("active");
  $("#modal-feedback-upload-image-preview .modal-wrapper img").attr("src", URL.createObjectURL(currentFile));
});
